import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Change Race";

const callChangeRace = async (
	race: string,
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$image: imageBase64,
					$race: race,
				},
				jwt,
				tool_document_id,
			};
			return fetchChangeRace(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchChangeRace(
	params: {
		inputs: {
			$image: string;
			$race: string;
		};
		jwt: string;
		tool_document_id: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenChangeRaceMessage() {
	useListenFromRenderer([
		{
			key: "changeRace",
			onMessage: async (message) => {
				const success = await callChangeRace(
					message.values.race,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
